import { NgModule, enableProdMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { routing } from './app.routes';

import { SharedModule } from './shared';
import { CoreModule } from './core';

import { AdminModule } from './admin';
import { SponsorModule } from './sponsor';
import { InvestigatorModule } from './investigator/investigator.module';
import { DashboardModule } from './dashboard';
import { GeneralDocumentsModule } from './general-documents/general-documents.module';
import { SitesModule } from './sites';
import { NavigationModule } from './navigation';
import { OnScreenResultsModule } from './on-screen-results/on-screen-results.module';
import { UserModule } from './user';
import { UserEmulationModule } from './user-emulation';
import { AuthenticationModule } from './authentication/authentication.module';
import { Settings } from './core/settings';

import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { CorporateModule } from './corporate/corporate.module';

import { deserialize } from 'santee-dcts';

import { MailLinksModule } from './mail-links/mail-links.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { EmulationInterceptor, TokenInterceptor } from './authentication/interceptors';
import { LoadingBarModule } from './loading-bar/loading-bar.module';
import { SampleTrackingModule } from './sample-tracking/sample-tracking.module';
import { SiteShippingToolModule } from './site-shipping-tool/site-shipping-tool.component.module';
import { SampleManagementModule } from './sample-management/sample-management.module';
declare const esaSettings: any;

const settings = deserialize(esaSettings, Settings);

console.debug('Bootstraping using the following settings:', esaSettings);

if (settings.angularEnableProdMode) {
    enableProdMode();
}

@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        CoreModule,
        CorporateModule,
        NgIdleKeepaliveModule.forRoot(),
        AuthenticationModule.forRoot(),
        AdminModule,
        SponsorModule,
        InvestigatorModule,
        DashboardModule,
        SitesModule,
        NavigationModule,
        SharedModule,
        GeneralDocumentsModule,
        routing,
        UserModule,
        UserEmulationModule,
        OnScreenResultsModule,
        AuthenticationModule,
        MailLinksModule,
        LoadingBarModule,
        SampleTrackingModule,
        SiteShippingToolModule,
        SampleManagementModule
    ],
    declarations: [
        AppComponent
    ],
    providers: [
        { provide: Settings, useValue: settings },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: EmulationInterceptor,
            multi: true
        }
    ],
    bootstrap: [AppComponent],
})
export class AppModule { }